import { Skeleton } from '@mui/material';

import './index.scss';

function SkeletonLoader() {
  return (
    <div className="contact-wrap">
      <Skeleton variant="text"  height={40} />

      <div className="skeleton contact-form-inner">
        <Skeleton variant="rectangular"  height={50}/>
        <Skeleton variant="rectangular"  height={50}/>
        <Skeleton variant="rectangular"  height={50}/>
        <Skeleton variant="rectangular"  height={50}/>
        <Skeleton variant="rectangular"  height={50}/>
        <Skeleton variant="rectangular"  height={50}/>
      </div>
    </div>
  )
}

export default SkeletonLoader;
